import Reveal, { SectionHeading } from "@/components/Reveal";

const STEPS = [
  {
    number: "01",
    title: "Say hello",
    copy: "Tell us about your business and what you need — a call, a message, or the form below. Straight talk, no jargon.",
  },
  {
    number: "02",
    title: "We design",
    copy: "First concepts land fast. We refine together until every pixel and every printed edge feels unmistakably you.",
  },
  {
    number: "03",
    title: "You launch",
    copy: "Website live, print delivered, artwork yours forever. We stay on hand whenever you need us next.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          index="03"
          eyebrow="The Process"
          title={<>Simple, honest, <span className="italic text-gold">fast.</span></>}
          className="mb-14 md:mb-20"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <Reveal key={s.number} delay={i * 0.15} className="bg-ink">
              <div data-testid={`process-step-${i + 1}`} className="group h-full p-8 md:p-12 hover:bg-surface transition-colors duration-500">
                <span className="font-display italic text-5xl md:text-6xl text-gold/70">{s.number}</span>
                <h3 className="mt-8 font-display text-2xl md:text-3xl tracking-tight">{s.title}</h3>
                <p className="mt-4 text-sm text-cream/55 font-light leading-relaxed">{s.copy}</p>
                <div className="mt-8 h-px w-10 bg-gold/50 transition-all duration-500 group-hover:w-20" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
